import React from 'react';

import Grid from '@mui/material/Grid2';

import { 
  DamageMultiplier
} from "@dndModels";
import { 
  DAMAGE_TYPES, 
  MULTIPLIER_OPTIONS
} from "@dndModels/Constants";

import SelectStringBox from "@components/input/selects/SelectStringBox";
import StringBox from "@components/input/strings/StringBox";

interface Props {
  obj: DamageMultiplier;
  onChange: (changed: DamageMultiplier) => void; 
  disabled: boolean;
}

export default function DamageMultiplierInput({ 
  obj,
  onChange,
  disabled
}: Props) {
  
  return (
    <Grid container spacing={0} direction="row">
      <Grid
        size={{
          xs: 12
        }}>
        <SelectStringBox 
          name="Damage Types" 
          multiple
          options={[...DAMAGE_TYPES,"Selectable Key","Use Extra"]}
          values={obj.the_damage_types} 
          disabled={disabled}
          onChange={(changed: string[]) => {
            const new_obj = obj;
            new_obj.the_damage_types = changed;
            onChange(new_obj);
          }} 
        />
      </Grid>
      { obj.the_damage_types.includes("Selectable Key") && 
        <Grid
          size={{
            xs: 12
          }}>
          <StringBox 
            name="Selectable Key" 
            value={obj.selectable_key} 
            disabled={disabled}
            onBlur={(changed: string) => {
              const new_obj = obj;
              new_obj.selectable_key = changed;
              onChange(new_obj);
            }} 
          />
        </Grid>
      }
      <Grid
        size={{
          xs: 12
        }}>
        <SelectStringBox 
          name="Multiplier" 
          options={MULTIPLIER_OPTIONS}
          value={`${obj.multiplier}`} 
          disabled={disabled}
          onChange={(changed: string) => {
            const new_obj = obj;
            new_obj.multiplier = +changed;
            onChange(new_obj);
          }} 
        />
      </Grid>
    </Grid>
  );
}
